import * as React from 'react';

var _g, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgBankOfAmerica = function SvgBankOfAmerica(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 20 20"
    }, props), _g || (_g = /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#clip0_1983_267)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#E31837",
        d: "M9.97 15.009C13.128 12.302 17.564 9.67 20 8.723c-.376-.24-.962-.586-1.624-.962-3.143 1.037-6.812 3.338-10.09 5.94.556.42 1.143.857 1.684 1.308"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#012169",
        d: "M8.526 7.655C8.06 7.43 7.55 7.22 7.158 7.04 5.97 7.625 4.42 8.512 2.466 9.91c.421.226.872.496 1.354.767 1.503-1.113 3.022-2.166 4.706-3.023"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E31837",
        d: "M11.338 6.362c-.571-.316-2.556-1.053-3.925-1.368-.406.15-.977.376-1.368.541.496.135 2.346.632 3.925 1.429.406-.196.977-.436 1.368-.602"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#012169",
        d: "M4.617 6.167C2.857 6.979 1.007 8.092 0 8.738c.36.166.722.3 1.218.541 2.226-1.503 3.97-2.42 4.662-2.721-.497-.18-.963-.301-1.263-.391"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E31837",
        d: "M12.662 5.896c.406-.135.872-.256 1.278-.376-1.173-.496-2.647-1.023-3.97-1.353-.21.06-.842.225-1.278.36.45.136 1.94.482 3.97 1.369M5.248 11.55c.481.286.993.677 1.489 1.008C10.03 10 13.278 8.03 16.842 6.918c-.496-.255-.932-.48-1.489-.751-2.135.541-5.789 2-10.105 5.383"
    }))), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "clip0_1983_267"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h20v20H0z"
    })))));
};

export { SvgBankOfAmerica as ReactComponent };
//# sourceMappingURL=BankOfAmerica.svg.es.js.map
